'use client'

import { CardsGroupBlock as CardsGroupBlockType } from '@/payload-types'
import { cn } from '@/utilities/ui'
import { Media } from '../components/Media/Media'
import { CMSLink } from '../components/CMSLink'
import { bagelFatOne, quicksand } from '@/utilities/fontImport'
import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { CardsGroupCard } from '../components/CardsGroupBlock/Cards'

export const CardsGroupBlock: React.FC<CardsGroupBlockType> = (props) => {
  const { sectionTitle, subtitle, displayMode, cards, backgroundMedia, foregroundMedia, links } =
    props

  const router = useRouter()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (searchParams.get('category')) return

    const firstCategoryCard = cards?.find((card) => card.categoryHandle)
    if (!firstCategoryCard?.categoryHandle) return

    const params = new URLSearchParams(window.location.search)
    params.set('category', firstCategoryCard.categoryHandle)
    router.replace(`?${params.toString()}`, { scroll: false })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <section className="relative isolate flex h-full flex-col justify-end overflow-hidden rounded-b-3xl">
      {backgroundMedia && typeof backgroundMedia === 'object' && (
        <Media
          resource={backgroundMedia}
          fill
          className="absolute inset-0 z-0"
          imgClassName="object-cover"
        />
      )}

      {sectionTitle && (
        <h2
          className={cn(
            'relative z-10 text-center text-3xl font-bold text-primary my-3 mt-16 md:mt-28',
            bagelFatOne.className,
          )}
        >
          {sectionTitle}
        </h2>
      )}

      {subtitle && (
        <h3
          className={cn(
            'relative z-10 text-center text-xl font-bold text-black my-2',
            quicksand.className,
          )}
        >
          {subtitle}
        </h3>
      )}

      {links && (
        <div className="flex justify-center gap-x-8 lg:pb-10 z-10">
          {links.map((link, index) => (
            <CMSLink key={index} {...link.link} iconClassName="ml-6" />
          ))}
        </div>
      )}

      <div
        className={cn(
          'relative mx-auto w-full max-w-7xl px-4 pb-10 mt-5 lg:mt-7',
          displayMode === 'grid' && 'grid grid-cols-2 gap-6 lg:grid-cols-4',
          displayMode === 'slider' && 'flex flex-nowrap gap-6 overflow-x-auto pb-4',
        )}
      >
        {cards?.map((card, index) => (
          <CardsGroupCard
            key={index}
            card={card}
            index={index}
            total={cards.length}
            displayMode={displayMode}
          />
        ))}
      </div>

      {foregroundMedia && typeof foregroundMedia === 'object' && (
        <Media
          resource={foregroundMedia}
          className="pointer-events-none absolute inset-x-0 bottom-0 z-20 w-full"
          imgClassName="w-full object-contain"
        />
      )}
    </section>
  )
}
